import React, { useEffect, useState } from "react";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../state";
import {
  MutateConnectToV2Protocol,
  MutateConnectToV2ProtocolReceiver,
  MutateDisconnectFromV2Protocol,
  MutateDisconnectFromV2ProtocolReceiver,
  MutateSetV2Mode,
} from "../../../utils/graphql/hooks/aksHooks";

export default function V2Controls() {
  const v2ConnectionState = useSelector(
    (state: RootState) => state.aks.v2ConnectedState,
  );

  const [connectionParams, setConnectionParams] = useState({
    host: "",
    port: 0,
    username: "",
    password: "",
  });

  const [activeReceiver, setActiveReceiver] = useState("");

  const connectToV2Protocol = MutateConnectToV2Protocol();
  const disconnectFromV2Protocol = MutateDisconnectFromV2Protocol();

  const connectToV2ProtocolReceiver = MutateConnectToV2ProtocolReceiver();
  const disconnectFromV2ProtocolReceiver =
    MutateDisconnectFromV2ProtocolReceiver();
  const setV2Mode = MutateSetV2Mode();

  useEffect(() => {
    if (v2ConnectionState.directConnectionParams) {
      setConnectionParams({
        host: v2ConnectionState.directConnectionParams.host,
        port: v2ConnectionState.directConnectionParams.port,
        username: v2ConnectionState.directConnectionParams.username,
        password: v2ConnectionState.directConnectionParams.password,
      });
    }
  }, [v2ConnectionState.directConnectionParams]);

  useEffect(() => {
    if (v2ConnectionState.activeReceiver) {
      setActiveReceiver(v2ConnectionState.activeReceiver);
    }
  }, [v2ConnectionState.activeReceiver]);

  return (
    <div className={styles.container}>
      <div
        className={`${styles.containerV2Controls} ${
          v2ConnectionState.connected || v2ConnectionState.retrying
            ? styles.disabledContainerV2Controls
            : ""
        }`}
      >
        <div className={styles.header}>V2 Mode</div>
        <div className={styles.modeSelection}>
          <div className={styles.receiverItem}>
            <input
              type="radio"
              id="mode-direct"
              name="v2mode"
              value="direct"
              checked={v2ConnectionState.connectionType === "direct"}
              onChange={() => setV2Mode({ variables: { mode: "direct" } })}
            />
            <label htmlFor="mode-direct">Direct</label>
          </div>
          <div className={styles.receiverItem}>
            <input
              type="radio"
              id="mode-receiver"
              name="v2mode"
              value="receiver"
              checked={v2ConnectionState.connectionType === "receiver"}
              onChange={() => setV2Mode({ variables: { mode: "receiver" } })}
            />
            <label htmlFor="mode-receiver">Receiver</label>
          </div>
        </div>
      </div>
      {v2ConnectionState.connectionType === "direct" && (
        <div className={styles.containerV2Controls}>
          <div className={styles.header}>V2 Controls</div>
          <div className={styles.v2ConnectionControls}>
            Host
            <input
              list="hosts"
              name="host"
              placeholder="Host"
              className={styles.v2Input}
              value={connectionParams.host}
              onChange={(e) =>
                setConnectionParams((prev) => ({
                  ...prev,
                  host: e.target.value,
                }))
              }
              disabled={
                v2ConnectionState.connected || v2ConnectionState.retrying
              }
            />
            Port
            <input
              type="number"
              placeholder="Port"
              className={styles.v2Input}
              value={connectionParams.port}
              onChange={(e) =>
                setConnectionParams((prev) => ({
                  ...prev,
                  port: parseInt(e.target.value) || 0,
                }))
              }
              disabled={
                v2ConnectionState.connected || v2ConnectionState.retrying
              }
            />
            User
            <input
              type="text"
              placeholder="Username"
              className={styles.v2Input}
              value={connectionParams.username}
              onChange={(e) =>
                setConnectionParams((prev) => ({
                  ...prev,
                  username: e.target.value,
                }))
              }
              disabled={
                v2ConnectionState.connected || v2ConnectionState.retrying
              }
            />
            Password
            <input
              type="password"
              placeholder="Password"
              className={styles.v2Input}
              value={connectionParams.password}
              onChange={(e) =>
                setConnectionParams((prev) => ({
                  ...prev,
                  password: e.target.value,
                }))
              }
              disabled={
                v2ConnectionState.connected || v2ConnectionState.retrying
              }
            />
            {(v2ConnectionState.connected || v2ConnectionState.retrying) &&
            v2ConnectionState.connectionType === "direct" ? (
              <button
                className={styles.connectButton}
                onClick={() => disconnectFromV2Protocol()}
              >
                Disconnect
              </button>
            ) : (
              <button
                className={styles.connectButton}
                onClick={() =>
                  connectToV2Protocol({
                    variables: { params: connectionParams },
                  })
                }
              >
                Connect
              </button>
            )}
            {v2ConnectionState.connected ? (
              <div className={styles.connectedStatus}>CONNECTED</div>
            ) : v2ConnectionState.retrying ? (
              <div className={styles.retryingStatus}>RETRYING</div>
            ) : (
              <div className={styles.disconnectedStatus}>NOT CONNECTED</div>
            )}
          </div>
        </div>
      )}
      {v2ConnectionState.connectionType === "receiver" && (
        <div
          className={`${styles.containerV2Controls} ${
            v2ConnectionState.connectedReceivers.length === 0
              ? styles.disabledContainerV2Controls
              : ""
          }`}
        >
          <div className={styles.header}>Online V2 Receivers</div>
          <div className={styles.connectReceiverContainer}>
            {v2ConnectionState.connectedReceivers.length === 0 && (
              <div className={styles.noReceivers}>No receivers connected</div>
            )}
            {v2ConnectionState.connectedReceivers?.map((receiver) => (
              <div key={receiver} className={styles.receiverItem}>
                <input
                  type="radio"
                  id={`receiver-${receiver}`}
                  name="receiver"
                  value={receiver}
                  checked={activeReceiver === receiver}
                  onChange={(e) => {
                    if (!v2ConnectionState.connected) {
                      setActiveReceiver(e.target.value);
                    }
                  }}
                />
                <label htmlFor={`receiver-${receiver}`}>{receiver}</label>
              </div>
            ))}
          </div>
          <div className={styles.v2ConnectionControls}>
            {(v2ConnectionState.connected || v2ConnectionState.retrying) &&
            v2ConnectionState.connectionType === "receiver" ? (
              <button
                className={styles.connectButton}
                onClick={() => disconnectFromV2ProtocolReceiver()}
              >
                Disconnect
              </button>
            ) : (
              <button
                className={styles.connectButton}
                onClick={() =>
                  connectToV2ProtocolReceiver({
                    variables: { receiverName: activeReceiver },
                  })
                }
              >
                Connect
              </button>
            )}
            {v2ConnectionState.connected ? (
              <div className={styles.connectedStatus}>CONNECTED</div>
            ) : v2ConnectionState.retrying ? (
              <div className={styles.retryingStatus}>RETRYING</div>
            ) : (
              <div className={styles.disconnectedStatus}>NOT CONNECTED</div>
            )}
          </div>
        </div>
      )}
      <div className={styles.containerV2Controls}>
        <div className={styles.header}>V2 Analytics</div>
        <div className={styles.v2ConnectionControls}>
          <div>Connected:</div>
          <div>
            {v2ConnectionState.analytics?.connectedTime
              ? new Date(
                  v2ConnectionState.analytics.connectedTime,
                ).toLocaleString()
              : "N/A"}
          </div>
          <div>Reset:</div>
          <div>
            {v2ConnectionState.analytics?.resetTime
              ? new Date(v2ConnectionState.analytics.resetTime).toLocaleString()
              : "N/A"}
          </div>
          <div>Messages:</div>
          <div>{v2ConnectionState.analytics?.totalMessages ?? "N/A"}</div>
        </div>
      </div>
    </div>
  );
}
